export const featureFlagUpdateEventName = 'featureFlagUpdate';

export const GENERAL_SETTINGS_EVENTS = {
  NOTIFICATION_PAGES: {
    TAB_VIEWED: "general_settings|notification_pages|tab_viewed",
    LOGO_UPLOADED: "general_settings|notification_pages|logo_uploaded",
    MESSAGE_UPDATED: "general_settings|notification_pages|message_updated",
    RESET_DEFAULTS: "general_settings|notification_pages|settings_reset_to_defaults",
    PREVIEW_CLICKED: "general_settings|notification_pages|preview_clicked",
    UPDATE_FAILED: "general_settings|notification_pages|update_failed",
    RESET_FAILED: "general_settings|notification_pages|reset_failed",
    DISPLAYED_INFO_UPDATED:
      "general_settings|notification_pages|displayed_information_updated",
  },
  SUPPORT_OPTIONS: {
    TAB_VIEWED: "general_settings|support_info|tab_viewed",
    SETTINGS_UPDATED: "general_settings|support_info_update",
    UPDATE_FAILED: "general_settings|support_info|update_failed",
  },
  GLOBAL_SETTINGS: {
    TAB_VIEWED: "general_settings|global_settings|tab_viewed",
    SETTINGS_UPDATED: "general_settings|global_settings|settings_updated",
    UPDATE_FAILED: "general_settings|global_settings|update_failed",
    PRE_LOGIN_TUNNEL_ENABLED: "general_settings|global_settings|pre_login_tunnel_enabled",
    PRE_LOGIN_TUNNEL_DISABLED: "general_settings|global_settings|pre_login_tunnel_disabled",
    SWITCH_USER_DETECTION_ENABLED: "general_settings|global_settings|switch_user_detection_enabled",
    SWITCH_USER_DETECTION_DISABLED: "general_settings|global_settings|switch_user_detection_disabled",
  },
} as const;

export const TRAFFIC_INSPECTION_EVENTS = {
  SECTION_VIEWED: "web_security|traffic_inspection|section_viewed",
  PORT_ADDED: "web_security|traffic_inspection|port_added",
  PORT_REMOVED: "web_security|traffic_inspection|port_removed",
  APPLY_CHANGES: "web_security|traffic_inspection|apply_changes",
  CONFIRM_APPLY_CHANGES: "web_security|traffic_inspection|confirm_apply_changes",
  CANCEL_APPLY_CHANGES: "web_security|traffic_inspection|cancel_apply_changes",
  ENABLE_SWG_CLICKED: "web_security|traffic_inspection|enable_swg_clicked",
  ENABLE_SWG_CONFIRMED: "web_security|traffic_inspection|enable_swg_confirmed",
  ENABLE_SWG_CANCELED: "web_security|traffic_inspection|enable_swg_canceled",
  CERT_ACTION_CHANGED: "web_security|traffic_inspection|cert_action_changed",
  CERT_LOG_TOGGLED: "web_security|traffic_inspection|cert_log_toggled",
} as const;

export const TRAFFIC_INSPECTION_TAG = "Traffic Inspection";

export const BRANDING_TAG = "notification_pages";
export const SUPPORT_INFO_TAG = "support_info";
export const GLOBAL_SETTINGS_TAG = "global_settings";